import clsx from 'clsx'
import React from 'react'

import { useThemeClass } from '../Theme'
import { TIMELINE_COMPONENT } from './constants'
import { NODE_KINDS } from './constants'
import styles from './style.module.scss'
import { ItemAlign } from './TimelineItem'
import { NodeKind } from './types'

export interface TimelineDesignProps {
  align?: ItemAlign
  hideLine?: boolean
  isVertical?: boolean
  highlight?: boolean
  nodeKind?: NodeKind
}

export const TimelineDesign = React.forwardRef<HTMLDivElement, TimelineDesignProps>(
  ({ align = '', hideLine = false, isVertical = false, highlight = false, nodeKind = 'Dot' }, ref): JSX.Element => {
    const themeClass = useThemeClass()

    const mainContainerstyles = clsx(styles.timelineDesign, isVertical && styles.timelineDesignV, styles[`timelineDesign${align}`])
    const circleStyles = clsx(
      styles.timelineDesignCircle,
      isVertical && styles.timelineDesignCircleV,
      highlight && styles.timelineDesignCircleHighlight,
      styles[themeClass]
    )
    const ellipsisStyles = clsx(styles.timelineDesignEllipsis, isVertical && styles.timelineDesignEllipsisV, styles[themeClass])
    const ellipsisContainerStyles = clsx(styles.timelineDesignEllipsisContainer, isVertical && styles.timelineDesignEllipsisContainerV, styles[themeClass])
    const dotStyles = clsx(styles.timelineDesignDot, styles[themeClass])
    const lineContainerStyles = clsx(
      styles.timelineDesignLineContainer,
      isVertical && styles.timelineDesignLineContainerV,
      styles[`timelineDesignLineContainer${align}`]
    )
    const lineStyles = clsx(
      styles.timelineDesignLine,
      isVertical && styles.timelineDesignLineV,
      hideLine && styles.timelineDesignNoLine,
      styles[`timelineDesignLine${align}`],
      styles[themeClass]
    )
    return (
      <div className={mainContainerstyles}>
        {nodeKind === NODE_KINDS.ELLIPSIS ? (
          <div className={ellipsisStyles}>
            <div className={ellipsisContainerStyles}>
              <div className={dotStyles} />
              <div className={dotStyles} />
              <div className={dotStyles} />
            </div>
          </div>
        ) : (
          <div className={circleStyles} />
        )}
        <div className={lineContainerStyles}>
          <div className={lineStyles} />
        </div>
      </div>
    )
  }
)

TimelineDesign.displayName = TIMELINE_COMPONENT
